import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    headerStyle: 't',
  },
  mutations: {
    headerStyle(state, type) {
      state.headerStyle = type
    },
  },
  actions: {

  }
})
